import type { UIMatch } from 'react-router-dom';
import { useMatches } from 'react-router-dom';

import { last } from 'lodash-es';

import type { LookoRouteHandle } from '@/router/LookoRouteObject';

/**
 * 현재 라우트의 마지막 매치를 가져옵니다.
 */
export const useLastMatches = () => {
  const matches = useMatches() as UIMatch<unknown, LookoRouteHandle | undefined>[];
  return last(matches);
};
